exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".patient-info{text-align:center;margin-top:20px;margin-bottom:20px}.patient-info img{margin-bottom:5px;width:100px;height:100px;border-radius:100%}.links{padding:15px}.links .link{margin-bottom:15px;position:relative;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/PatientMenu/PatientMenu.scss
// module id = 591
// module chunks = 0